import React from 'react'
import './Interfa.css'
import dev from './dev.gif'
function Interfa() {
  return (
      <div className='Interface'>
          <div className='Intim'>
              <img src={dev} alt=''/>
          </div>
          <div className='lower'>
              <h2 className='Intex'>Hey, Ram here</h2>
              <h5 >Welcome...</h5>
              <span class="loader"></span>
          </div>
    </div>
  )
}

export default Interfa